import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker, InfoWindow} from 'google-maps-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import axios from '../../../axios/axios';
import locationIcon from './../../../assets/images/icons/icon_geo.svg';
import nearestLocation from './../../../assets/images/icons/geo.svg';
import { translateStaticContent } from '../../../helpers/translateStaticContent';
import Search from './Search';

export class Maps extends Component {
  constructor(props) {
    super(props);

     this.state = {
       currentLocation: {
         lat: null,
         lng: null,
       },
       nearestLocation: {
        lat: null,
        lng: null,
      },
       markers: [],
       activeMarker: {},
       selectedPlace: {},
       showingInfoWindow: false,
       infoWindow: null,
       searchValue: '',
       searchAddress: [],
       showNearestMarker: true,
       zoom: 8,
     }
   }
   
  showCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          this.setState({...this.state, currentLocation: {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }, showNearestMarker: true}, () => this.findNearestMarker())
        }
      )
      setTimeout(() => {
        if (this.state.currentLocation.lng === null && this.state.currentLocation.lat === null) {
          this.setState({...this.state, currentLocation: {
            lat: 50.4536,
            lng: 30.5164
          }, showNearestMarker: false})
        }
      }, 100)
    } else {
      error => console.log(error)
    }
  }

  componentDidMount() {
    this.showCurrentLocation();
    this.getPoints();
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeLang !== prevProps.activeLang) {
      this.getPoints();
    }
  }

  getPoints = () => {
    let data = [];
    axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
    axios.get(`/api/welsend/public/points`)
    .then(res => {data = res.data})
    .then(() => {
      const infoWindow = <InfoWindow marker={this.state.activeMarker} visible={this.state.showingInfoWindow}
          position={{
              lat: +this.state.activeMarker.latitude,
              lng: +this.state.activeMarker.longitude,
            }}
          >
        <div></div>
      </InfoWindow>
      this.setState({...this.state, markers: data, infoWindow: infoWindow}, () => {this.findNearestMarker()})
    })
  }

  findNearestMarker = () => {
    let minDistance = 0;
    let counter = 0;
    this.state.markers.forEach((marker) => {
      if (marker.longitude !== null && marker.latitude !== null) {
            if (counter === 0) {
              minDistance = this.calcCrow(this.state.currentLocation.lat, this.state.currentLocation.lng, 
                                          marker.latitude, marker.longitude);
              this.setState({...this.state, nearestLocation: {
                  lat: marker.latitude,
                  lng: marker.longitude,
                }
              })
              counter++;
            } else {
              const distance = this.calcCrow(this.state.currentLocation.lat, this.state.currentLocation.lng, 
                                          marker.latitude, marker.longitude);
              if (distance < minDistance) {
                minDistance = distance;
                this.setState({...this.state, nearestLocation: {
                    lat: marker.latitude,
                    lng: marker.longitude,
                  }
                })
                counter++;
            }}
        }
    }); 
  }

  calcCrow = (fromLat, fromLng, toLat, toLng)  => {
      let radius = 6371; 
      let dLat = this.toRad(toLat-fromLat);
      let dLng = this.toRad(toLng-fromLng);
      let fromLatConverted = this.toRad(fromLat);
      let toLatConverted = this.toRad(toLat);

      let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLng/2) * Math.sin(dLng/2) * Math.cos(fromLatConverted) * Math.cos(toLatConverted); 
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      let distance = radius * c;
      return distance;
    }

  toRad = (value)  => {
      return value * Math.PI / 180;
  }

  getMarkers() {
    let location = '';
    const allMarkers = this.state.markers.map((marker) => {
      if (marker.longitude === this.state.nearestLocation.lng &&
         marker.latitude === this.state.nearestLocation.lat &&
         this.state.nearestLocation.lng !== null &&
         this.state.nearestLocation.lat !== null &&
         this.state.showNearestMarker) {
           location = `${nearestLocation}`;
        } else if (marker.longitude === null && marker.latitude === null) {
           return;
        } else {
          location = `${locationIcon}`;
        }
    return <Marker key={marker.pointId} id={marker.pointId} pointCanReceive={marker.pointCanReceive} 
                      pointWorkSchedule={marker.pointWorkSchedule} address={marker.address}
                      phone={marker.phone} name={marker.name} position={{lat: marker.latitude, lng: marker.longitude}}
                      icon={{
                        url: location ? `${location}` : null
                        }}
                      onClick={this.onMarkerClick}>
         </Marker>
    })
    return allMarkers;
  }

  onMarkerClick = (props, marker) => {
    this.getAddressFromCoordinates(marker, props.position.lng, props.position.lat);
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      currentLocation: {
        lat: props.position.lat,
        lng: props.position.lng
      }
     });
  }

  getAddressFromCoordinates(marker, longitude, latitude) {
    const apiKey = 'AIzaSyAXVoume29wml8rFbbb_cFT2miwjGBvumE';
    const activeLang = this.props.activeLang ? this.props.activeLang : 'uk';
    const staticMarkerPlace = translateStaticContent('markerPlace', 
                              this.props.defaultStaticContentMap, this.props.activeLangStaticContentMap);
    const staticMarkerAddress = translateStaticContent('markerAddress', 
                              this.props.defaultStaticContentMap, this.props.activeLangStaticContentMap);
    const staticMarkerPhone = translateStaticContent('markerPhone', 
                              this.props.defaultStaticContentMap, this.props.activeLangStaticContentMap); 
    const staticMarkerHours = translateStaticContent('markerHours', 
                              this.props.defaultStaticContentMap, this.props.activeLangStaticContentMap);
    const staticMarkerInfo = translateStaticContent('markerInfo', 
                              this.props.defaultStaticContentMap, this.props.activeLangStaticContentMap); 
    const staticMarkerPos = translateStaticContent('markerPos', 
                              this.props.defaultStaticContentMap, this.props.activeLangStaticContentMap);       
    return new Promise((resolve) => {
      const url = `/maps/api/geocode/json?latlng=${latitude},${longitude}&language=${activeLang}&key=${apiKey}`;
      axios.get(url)
      .then(() => { 
          const infoWindow = <InfoWindow marker={this.state.activeMarker} visible={this.state.showingInfoWindow}
          position={{
              lat: +latitude,
              lng: +longitude
            }}
          >
            <div className='info'>
              <div><span>{staticMarkerPlace}: </span>{marker.name}</div>
              <div><span>{staticMarkerAddress}: </span>{marker.address}</div>
              <div><span>{staticMarkerPhone}: </span>{marker.phone}</div>
              <div><span>{staticMarkerHours}: </span>{marker.pointWorkSchedule}</div>
              <div style={marker.pointCanReceive ? '' : {display:'none'}}><span>{staticMarkerInfo}: 
                </span>{marker.pointCanReceive ? staticMarkerPos : ''}</div>
            </div>
          </InfoWindow>
              this.setState({...this.state, 
                                activeMarker: marker, 
                                showingInfoWindow: true,
                                infoWindow: infoWindow,
                                selectedPlace: marker,
                              })
        })
      .catch((e) => {
          console.log('Error in getAddressFromCoordinates', e)
          resolve()
        })
    })
  }

  setSelectedAdress = (location, address) => {
   this.setState({...this.state, currentLocation: {
        lat: location.lat,
        lng: location.lng
      },
      searchValue: address,
      zoom: 11,
      searchAddress: []
    })
  }

  render() {
      const mapStyles = {
        width: "100%",
        height: "100%",
        position: "relative"
      };
      return (
         <div className='map container'>
            <h1>
              {translateStaticContent('mapHeading', 
                this.props.defaultStaticContentMap, this.props.activeLangStaticContentMap)}
            </h1>
             
            <Search defaultStaticContentMap={this.props.defaultStaticContentMap}
                    activeLang={this.props.activeLang}
                    selectedAdress={this.setSelectedAdress}
                    showCurrentLocation={this.showCurrentLocation}
                    activeLangStaticContentMap={this.props.activeLangStaticContentMap}/>
            <div className='map-container'>
              <Map 
                  className='map'
                  google={this.props.google}
                  zoom={this.state.zoom}
                  style={mapStyles}
                  center={{ lat: this.state.currentLocation.lat, lng: this.state.currentLocation.lng }}
                >
                {this.getMarkers()}
                {this.state.infoWindow}
              </Map> 
            </div>
         </div>
      );
    }
  }

  const mapStateToProps = state => ({
    activeLang: state.lang.activeLang
  })

  const WrappedContainer = GoogleApiWrapper({
    apiKey: 'AIzaSyAXVoume29wml8rFbbb_cFT2miwjGBvumE'
    })(Maps);
    
  export default connect(mapStateToProps)(WrappedContainer);

Maps.propTypes = {
  google: PropTypes.object.isRequired,
  zoom: PropTypes.number,
  initialCenter: PropTypes.object,
  centerAroundCurrentLocation: PropTypes.object,
  activeLang: PropTypes.string.isRequired,
  defaultStaticContentMap: PropTypes.object,
  activeLangStaticContentMap: PropTypes.object,
}
